/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';

import * as types from './actionTypes';

export const setGrouping = createAction(types.SET_GROUPING);
